import React from "react";
// import "./TermsAndConditions.css";

const ReplacementServicePolicy = () => {
    return (
        <div className="tc-container">
            <h1 className="tc-title">Replacement & Service Policy</h1>

            <section className="tc-section">
                <h2>1. Eligibility for Replacement / Service</h2>
                <p>
                    Replacement or service requests are accepted only in specific, verifiable cases
                    to ensure product quality and prevent misuse.
                </p>
                <p>A request may be considered under the following conditions:</p>
                <ul>
                    <li>Manufacturing defects affecting normal functionality</li>
                    <li>Product received in damaged condition due to transit</li>
                </ul>
                <p>
                    All requests are subject to review and approval by Way4Track.
                </p>
            </section>

            <section className="tc-section">
                <h2>2. Request Time Window</h2>
                <p>
                    Customers must raise a replacement or service request within <strong>5 calendar days</strong>
                    from the date of delivery.
                </p>
                <ul>
                    <li>Ensures issues are verified at delivery time</li>
                    <li>Prevents claims after extended usage</li>
                    <li>Enables efficient resolution</li>
                </ul>
                <p>
                    Requests submitted after this period may be rejected due to verification limitations.
                </p>
            </section>

            <section className="tc-section">
                <h2>3. Conditions for Approval</h2>
                <p>To qualify for replacement or service:</p>
                <ul>
                    <li>Product should be unused or used only for initial testing</li>
                    <li>No physical damage, tampering, or unauthorized modifications</li>
                    <li>Return must include all original items:</li>
                    <ul>
                        <li>Packaging box</li>
                        <li>Accessories</li>
                        <li>Manuals (if applicable)</li>
                    </ul>
                </ul>

                <p>Customers must provide clear evidence:</p>
                <ul>
                    <li>Photos/videos of the defect</li>
                    <li>Product condition</li>
                    <li>Packaging condition (for transit damage)</li>
                </ul>

                <p>
                    Incomplete or unclear submissions may result in rejection.
                </p>
            </section>

            <section className="tc-section">
                <h2>4. Verification & Technical Assessment</h2>
                <p>
                    Way4Track may perform technical evaluation before approval.
                </p>
                <ul>
                    <li>Remote troubleshooting</li>
                    <li>Diagnostic verification steps</li>
                    <li>Inspection at authorized service center (if required)</li>
                </ul>
                <p>
                    This ensures accurate identification of manufacturing defects versus external damage.
                </p>
            </section>

            <section className="tc-section">
                <h2>5. Resolution (Repair or Replacement)</h2>
                <p>
                    Based on evaluation, Way4Track will determine the appropriate resolution:
                </p>
                <ul>
                    <li>Repair of defective components</li>
                    <li>Replacement of product or specific parts</li>
                </ul>
                <p><strong>Important:</strong></p>
                <ul>
                    <li>Replacement is not guaranteed in all cases</li>
                    <li>Repair may be preferred where feasible</li>
                    <li>Partial replacement may be applied for multi-component products</li>
                </ul>
                <p>
                    The final decision will be binding based on technical assessment.
                </p>
            </section>

            <section className="tc-section">
                <h2>6. No Refund Policy</h2>
                <p>
                    Once an order is confirmed, refunds are not applicable under replacement or service requests.
                </p>
                <p>
                    Resolution is strictly limited to repair or replacement to restore functionality.
                </p>
            </section>

            <section className="tc-section">
                <h2>7. Non-Eligible Cases</h2>
                <p>Requests will be rejected in the following situations:</p>
                <ul>
                    <li>Damage due to misuse, negligence, or improper handling</li>
                    <li>Products that are opened, modified, or tampered</li>
                    <li>Unauthorized installation or repair</li>
                    <li>Damage caused by external factors:</li>
                    <ul>
                        <li>Water exposure</li>
                        <li>Fire damage</li>
                        <li>Electrical fluctuations</li>
                    </ul>
                    <li>Missing original packaging or accessories</li>
                    <li>Requests raised after the allowed time window</li>
                </ul>
            </section>

            <section className="tc-section">
                <h2>8. Return & Logistics</h2>
                <p>If a request is approved:</p>
                <ul>
                    <li>Product must be sent to the designated service center</li>
                    <li>Instructions will be shared post-approval</li>
                </ul>
                <p><strong>Customer Responsibilities:</strong></p>
                <ul>
                    <li>Secure packaging to prevent transit damage</li>
                </ul>
                <p>
                    Way4Track is not responsible for damage during return shipment due to improper packaging.
                </p>
                <p>
                    Shipping cost responsibility will be communicated on a case-by-case basis.
                </p>
            </section>

            <section className="tc-section">
                <h2>9. Misuse & Claim Monitoring</h2>
                <p>
                    Way4Track actively monitors claim patterns to prevent abuse.
                </p>
                <ul>
                    <li>Repeated or suspicious claims may be rejected</li>
                    <li>Accounts may be restricted</li>
                    <li>Further action may be taken if misuse is detected</li>
                </ul>
            </section>

            <section className="tc-section">
                <h2>10. Final Decision</h2>
                <p>
                    All requests are subject to internal review and final approval by Way4Track.
                </p>
                <p>Decisions are based on:</p>
                <ul>
                    <li>Technical evaluation</li>
                    <li>Submitted evidence</li>
                    <li>Internal quality checks</li>
                </ul>
                <p>
                    The Company’s decision shall be final and binding.
                </p>
            </section>

        </div>
    );
};

export default ReplacementServicePolicy;